import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { CharValue } from 'src/app/models/interface/product/charValue';
import { CharValueObject } from '../../char-value-object.model';

export class AddressObject {

    constructor(private specId: string, private charValues: CharValueObject[]) {
    }

    public getSpecId(): string {
        return this.specId;
    }

    public getCharValues(): CharValueObject[] {
        return this.charValues;
    }
}
